import { Pipe, PipeTransform } from '@angular/core';
import { TokenService } from '../../api';

@Pipe({
  name: 'authenticated',
})
export class AuthenticatedPipe implements PipeTransform {
  constructor(private readonly service: TokenService) {}

  public transform(value: string): string {
    return `${value}${value.includes('?') ? '&' : '?'}token=${this.service.getToken()}`;
  }
}
